import Vue from 'vue'

import '../config/global.js';  //常量
import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css
import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control
import VueTinymce from "@packy-tang/vue-tinymce"
import BaiduMap from 'vue-baidu-map'

// import VideoPlayer from 'vue-video-player'
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')


//安装组件
// Vue.use(VideoPlayer)
Vue.use(BaiduMap, {
  ak: 'hmCltQ7iQb3l1VAUze6Ll9sVpNT6F1IM'
})
Vue.use(VueTinymce)
Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false

Vue.directive('lazy',(el,binding)=>{
  let oldSrc = el.src
  el.src = ""
  let observer = new IntersectionObserver(([{isIntersecting}]) => {
    if(isIntersecting){
      el.src = oldSrc
      observer.unobserve(el)
    }
  },{threshold:0.01})
  observer.observe(el)
})


new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js